<template>
  <div class="relative px-2 py-2">
    <div
      class="data-container rounded font-mono text-xs w-full whitespace-pre-wrap"
      :class="currentRecord ? 'p-4' : 'p-2'"
    >
      <pre v-if="currentRecord" class="break-all whitespace-pre-wrap">{{
        currentRecord
      }}</pre>
      <div v-else class="secondary_color text-[11px]">
        Please verify to see &nbsp;current record
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  row: { type: Object, required: true },
});

const currentRecord = computed(() => {
  if (!props.row || !props.row.current_record) return "";
  return props.row.current_record;
});
</script>

<style scoped>
.break-all {
  word-break: break-all;
}
.data-container {
  background: var(--white-opacity-4);
  min-width: 200px;
}
</style>
